export { default } from './LeilaoDeVeiculosBanner';
